import api from 'base/utils/api';
import { IGetActivityReviewPageParams, IGetReviewPageParams, IReviewPage } from 'mod/review/interface';

// 获取评论列表
export async function getReviewPage(params: IGetReviewPageParams): Promise<IReviewPage> {
    return api.get('/web/product/review-list/v2', { params })
}

// 获取活动评论
export async function getActivityReviewPage(params: IGetActivityReviewPageParams): Promise<IReviewPage> {
    return api.post('/web/product/review-list/activity', {
        data: params
    })
}

export async function getFirstReviewPage(variantId: string, pageSize: number = 10): Promise<IReviewPage> {
    return getReviewPage({
        productVariantId: variantId || '',
        page: 1,
        pageSize,
        withPictures: 0
    })
}
